"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var moment_1 = __importDefault(require("moment"));
var env_var_helpers_1 = require("env-var-helpers");
var mobx_1 = require("mobx");
/**************************************** PROJECT MODULES *****************************************/
var javelin_exports_1 = require("../javelin-exports");
var store_1 = require("../data/store/store");
var api_routes_1 = require("../config/api-routes");
var sync_utils_1 = require("./sync-utils");
var SSTemp = __importStar(require("../util/temp-localforage-storage"));
/******************************************** LOGGING *********************************************/
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory("javelin-sync.ts", shared_1.Styles.lucky);
var cl = "JavelinSync";
var sFn = cl + "#initiateSync ::";
/********************************************* EXPORT *********************************************/
/**
 * Class with the necessary methods for sync
 * @author Andrew Faulkner
 * @since 2.5.0
 */
var JavelinSync = /** @class */ (function () {
    function JavelinSync(urlConfigs) {
        this.isEnabled = false;
        this.syncManager = null;
        this.store = store_1.store;
        /****** HELPERS ******/
        /**
         * Handle failed sync attempt: broadcast event announcing that sync finished,
         * re-include transactions in pending transactions array in store, log error
         */
        this.handleSyncFail = function (transactions, msg, recordId) { return function (e) {
            store_1.store.jvlnsBroadcaster.emitBroadcast("ev_SYNC_COMPLETE", __assign({}, e, { recordId: recordId }));
            store_1.store.addTransactions(transactions);
            log.error(sFn + " syncManager.sync " + msg + ":", e, "store.transactions:", store_1.store.transactions);
        }; };
        this.urlConfigs = urlConfigs || api_routes_1.apiRoutes;
        this.store = store_1.store;
    }
    /**
     * This must be run before JavelinSync will work
     * @param {SyncManagerInstance} syncManager Required for JavelinSync to work correctly
     */
    JavelinSync.prototype.initialize = function (syncManager) {
        this.isEnabled = true;
        this.syncManager = syncManager;
    };
    /****** REQUIRED METHODS ******/
    /**
     * Sets the last successful sync date to now
     * @param recordId Id of the Record that this concerns
     */
    JavelinSync.prototype.saveLastSyncDate = function (recordId) {
        var fn = cl + "#saveLastSyncDate";
        log.verbose(fn + ": recordId:", recordId);
        if (!this.isEnabled)
            return log.warn("FAILED: " + cl + "#initialize must run before " + fn);
        // Get current record from store
        var record = store_1.store.getRecordById(recordId);
        log.verbose(fn + ": record:", record);
        // Save latest sync date/time in the store
        store_1.store.lastSyncTimestamp = new javelin_exports_1.ZonedDateTime(moment_1.default());
        log.info(fn + ": store.lastSyncTimestamp:", store_1.store.lastSyncTimestamp, "recordId:", recordId);
        // Save new sync date/time in the record (if record is present)
        if (record) {
            record.lastSyncTimestamp = new javelin_exports_1.ZonedDateTime(moment_1.default());
            log.verbose(fn + ": record.lastSyncTimestamp:", record.lastSyncTimestamp);
        }
    };
    /**
     * Makes a GET request for logging in or signing a user up
     *
     * @param endpoint Endpoint to make the request to
     * @param cookies  String representing cookie(s) to add to call, null if none
     * @param params   Params to add to the request, empty map if none
     * @param cb Callback
     */
    JavelinSync.prototype.get = function (endpoint, cookies, params, cb) {
        var _this = this;
        if (!this.isEnabled)
            return console.warn("FAILED: " + cl + "#initialize must run before .get");
        // Store response code when in interim step
        var resCode;
        var cleanParams = typeof params.getObject === "function" ? params.getObject() : params;
        if (!cleanParams.buildType)
            cleanParams.buildType = env_var_helpers_1.releaseEnvShort;
        sync_utils_1.syncFetch("GET", this.urlConfigs, endpoint, cookies, null, cleanParams)
            .then(function (res) {
            resCode = res.status;
            log.verbose(cl + "#get :: first then :: res:", res);
            return res.text();
        })
            .then(function (data) {
            log.info(cl + "#get :: 2nd then (final returned data) :: data:", data);
            var res = cb.onSuccess(resCode, data, []);
            // If logout detected, broadcast that a logout occurred
            if (endpoint === "logout") {
                _this.store.jvlnsBroadcaster.emitBroadcast("ev_LOGOUT", true);
            }
            return res;
        })
            .catch(function (err) {
            log.error(cl + "#get :: catch :: err:", err);
            return cb.onFailure(typeof err === "string" ? err : err.message);
        });
    };
    /**
     * Makes a POST or PUT request (of given type), for logging in, signing a
     * user up, or resetting password
     *
     * @param endpoint Endpoint to make the request to
     * @param cookies  String representing cookie(s) to add to call, null if none
     * @param body     String to use as the body
     * @param callback Callback
     */
    JavelinSync.prototype.postOrPut = function (reqType, endpoint, cookies, body, callback) {
        var _this = this;
        var fn = "JavelinSync#postOrPut :: syncFetch POST/PUT request [fn -> postOrPut] --";
        if (!this.isEnabled) {
            return console.warn("[JavelinSync] WARNING: .initialize method must run before .post");
        }
        // Signal start of record ID fetching, if that's what the request is for
        if (endpoint === "record-ids") {
            this.store.jvlnsBroadcaster.emitBroadcast("ev_RECORD_IDS_START_FETCH", true);
        }
        var recordIds = [];
        // Store response code when in interim step
        var responseCode;
        // Holds response object clone to get text from if parsing response as JSON fails
        var responseClone = null;
        /*
         * Perform POST/PUT request
         */
        sync_utils_1.syncFetch(reqType, this.urlConfigs, endpoint, cookies, body)
            /*
             * Try treating response as JSON data
             */
            .then(function (res) {
            responseCode = res.status;
            log.verbose(fn + " raw response (res)", res, "\nresponseCode: " + responseCode);
            responseClone = res.clone();
            return res.json();
        })
            /*
             * If JSON parse succeeds, store response for temp use (if needed)
             */
            .then(function (data) {
            if (endpoint === "record-ids") {
                recordIds = data;
                log.info(fn + " record-ids came back -- data: ", data);
            }
            else {
                log.info(fn + " \"then\" # 2: successfully parsed JSON response data:", data);
            }
            return SSTemp.setItem("JavelinSync#post", data);
        })
            /*
             * If JSON parse & storage succeeds, pass response data as a string
             * to success handler
             */
            .then(function (data) {
            return callback.onSuccess(responseCode, JSON.stringify(data), [data.accessToken]);
        })
            /*
             * Handle responses that can't be JSON parsed
             */
            .catch(function (err) {
            log.info(fn + " Treating response as text (parsing it as JSON failed):", err);
            // Try treating response as a text string
            // if it fails, return empty string
            return responseClone != null && responseClone && responseClone.text
                ? responseClone
                    .text()
                    .catch(function (_e) { return ""; })
                    // Return final resultant string to success handler
                    // (with no cookie extracted)
                    .then(getSyncPostTextSuccessCb(responseCode, callback))
                    .catch(getSyncPostTextCbFail(fn))
                : Promise.resolve("")
                    // Return empty string
                    .then(getSyncPostTextSuccessCb(responseCode, callback))
                    .catch(getSyncPostTextCbFail(fn));
        })
            /*
             * Wipe temporarily stored response (whether present or not)
             */
            .then(function () { return SSTemp.clearAll(); })
            .then(function () { return log.verbose(fn + " successfully cleared all data from temp!"); })
            .catch(function (err) { return log.error(fn + " Failed to clear data from temp:", err); })
            /*
             * Signal end of record ID fetching (if that was purpose of request)
             */
            .then(function () {
            if (endpoint === "record-ids") {
                _this.store.jvlnsBroadcaster.emitBroadcast("ev_RECORD_IDS_FETCH_COMPLETE", recordIds);
            }
        });
    };
    /**
     * Makes a POST request for logging in or signing a user up [login & signup]
     *
     * @param endpoint Endpoint to make the request to
     * @param cookies  String representing the cookie(s) to add to the call, null if none
     * @param body     String to use as the body
     * @param callback Callback
     */
    JavelinSync.prototype.post = function (endpoint, cookies, body, callback) {
        return this.postOrPut("POST", endpoint, cookies, body, callback);
    };
    /**
     * Makes a PUT request for resetting the user's password
     *
     * @param endpoint  Endpoint to make the request to
     * @param cookies   String representing the cookies to add to the call, null if none
     * @param body      String to use as the message body
     * @param callback  Callback
     */
    JavelinSync.prototype.put = function (endpoint, cookies, body, callback) {
        return this.postOrPut("PUT", endpoint, cookies, body, callback);
    };
    /**
     * Makes a request of [type] at the [endpoint], with [cookies], query
     *  [initialParams], and a [body] if this is a POST/PUT
     *  Uses the [callback] when there's an error & calls [success] if the call was successful
     */
    JavelinSync.prototype.makeRequest = function (type, endpoint, cookies, params, body, callback) {
        logReqArgs(type, endpoint, cookies, params, body, callback);
        switch (type.name) {
            case "GET":
                return this.get(endpoint, cookies || "", params, callback);
            case "POST":
                return this.post(endpoint, cookies || "", mergeBodyParams(body, params), callback);
            case "PUT":
                return this.put(endpoint, cookies || "", mergeBodyParams(body, params), callback);
            default:
                log.error("JavelinSync#makeRequest :: Unknown request type: " + type.name);
        }
    };
    /**
     * Requests a sync call to be made
     *
     * @param recordId      Id of the {@link Record} to sync
     * @param serverRequest True if this is a request from the server, false otherwise
     */
    JavelinSync.prototype.initiateSync = function (recordId, serverRequest) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                requestAnimationFrame(function () {
                    log.info(sFn + " :: [RAF ENTRY] store.transactions:", store_1.store.transactions);
                    if (!_this.isEnabled) {
                        return console.warn("FAILED: " + cl + "#initialize must run before " + sFn);
                    }
                    // Emit event identifying that a sync has started (for given recordId)
                    store_1.store.jvlnsBroadcaster.emitBroadcast("ev_SYNC_START_FETCH", recordId);
                    // Get transactions to include in request
                    var transactions = store_1.store.getTransactionsByRecordId(recordId);
                    log.verbose(sFn + " :: transactions in request:", transactions);
                    // # of transactions request will include
                    // Reduce pendingRequests by this # on successful request completion
                    // Note that if this = 0, it will still reduce pendingRequests by 1
                    var numTransactionsInRequest = mobx_1.toJS(transactions.length);
                    log.verbose(sFn + " :: numTransactionsInRequest in request:", numTransactionsInRequest);
                    // Request to update the record
                    try {
                        _this.syncManager.sync(recordId, serverRequest, new javelin_exports_1.RequestCallback({
                            onSuccess: function (data) {
                                log.info(sFn + " syncManager.sync success! data:", data);
                                store_1.store.jvlnsBroadcaster.emitBroadcast("ev_SYNC_COMPLETE", __assign({}, data, { recordId: recordId }), numTransactionsInRequest);
                            },
                            onError: _this.handleSyncFail(transactions, "request error", recordId),
                        }));
                        // Eliminate sent transactions from transactions-to-send array
                        // (Error handlers reinsert them, to allow reattempt to save if sync fails)
                        transactions.forEach(mobx_1.action(function (trans) { return store_1.store.transactions.remove(trans); }));
                    }
                    catch (error) {
                        _this.handleSyncFail(transactions, "threw", recordId)(error);
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    return JavelinSync;
}());
exports.JavelinSync = JavelinSync;
/******************************************** HELPERS *********************************************/
/**
 * Safely build conglomerate body + params object for POST & PUT requests
 */
function mergeBodyParams(body, params) {
    var paramObj = (params && params.getObject && params.getObject()) || {};
    if (!paramObj.buildType)
        paramObj.buildType = env_var_helpers_1.releaseEnvShort;
    return JSON.stringify(__assign({}, JSON.parse(body || "{}"), paramObj));
}
/**
 * Log arguments for JavelinSync#makeRequest
 */
function logReqArgs(type, endpoint, cookies, params, body, callback) {
    // prettier-ignore
    log.info("[JavelinSync] -> makeRequest ::", "\n type:", type, "\n endpoint:", endpoint, "\n cookies:", cookies, "\n params:", params, "\n body:", body, "\n callback:", callback);
}
/**
 * Run returned function if extracting text from POST fetch request is
 * successful (or if we want it to return ``)
 * @param {number} resCode Response code
 * @param {Function} cb Callback object - run the onSuccess function it contains
 */
function getSyncPostTextSuccessCb(resCode, callback) {
    return function (txt) { return callback.onSuccess(resCode, txt, null); };
}
/**
 * Run returned function if cb run after extracting text from POST fetch
 * request fails / produces a promise rejection
 * @param {string} srcFn Name of source function (for logging purposes)
 */
function getSyncPostTextCbFail(srcFn) {
    return function (err) { return log.error(srcFn + " Failed to call onSuccess:", err); };
}
//# sourceMappingURL=javelin-sync.js.map